import { useParams } from "react-router-dom";
import React from "react";
import MissionTasksContext from "modules/pvs_activities/components/contexts/MissionTasksContext";
import MissionDetail from "./MissionDetail";


const MissionProcess = () => {

  const { id, page } = useParams();

  return (
    <MissionTasksContext missionId={id}>
      <MissionDetail page={page} />
    </MissionTasksContext>
  );
};

export default MissionProcess;
